import { TBaseObj } from '../types/types';

/**
 *
 * @param {String} url
 * @return {boolean}
 */
function isInternalUrl(url: string | undefined): boolean {
  if (url) return url.startsWith('/') || url.startsWith('#');
  return false;
}

export const getExternalLinkRelAttribute = (url = ''): TBaseObj => {
  return isInternalUrl(url) ? {} : { rel: 'nofollow' };
};

function appendToUrlPath(url: string, add: string): string {
  const appendSlash = (newurl: string): string => (newurl.endsWith('/') ? newurl : `${newurl}/`);
  const appendString = add || '';

  if (!url) {
    return '';
  } else if (url.includes('?')) {
    const urlArray = url.split('?');

    return `${appendSlash(urlArray[0])}${appendString}?${urlArray[1]}`;
  } else if (url.includes('#')) {
    const urlArray = url.split('#');

    return `${appendSlash(urlArray[0])}${appendString}#${urlArray[1]}`;
  } else {
    return `${appendSlash(url)}${appendString}`;
  }
}

function removeTrailingSlashFromPath(path: string): string {
  return path.endsWith('/') ? path.slice(0, -1) : path;
}

export { isInternalUrl, appendToUrlPath, removeTrailingSlashFromPath };
